// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Rh0r","tabsBox":"styles_tabsBox__F-2OI","createButton":"styles_createButton__1v01_"};